import React from "react";
import {rootActions, useAppDispatch, useAppSelector} from "../DAL/store";
import ArrowIcon from "../../../ui/svg/common/arrow";
import {AddToCart, SetIsAnnual} from "../services/logic-helper";
import {SubscriptionPlanModel} from "../interfaces";
import {sendGAEvent} from "../../../domain/marketing/gtm-provider";
import {Price} from "./price";
import StarRating from "../../../ui/rating/star-rating";
import SbsPlansArrowIcon from "../icons/sbs-plans-arrow";
import ProductPriceFormat from "../../products/product-price/product-price-format";
import {ToggleStyled} from "../../../ui/toggle/toggle-styled";
import {PriceDifferent} from "./price-different";
import TwoMonthFree from "./two-month-free/two-month-free";
import TwoMonthFreePriceDifferent from "./two-month-free/two-month-free-price-different";
import InfoIcon from "../../../ui/svg/common/info";
import {CrediteTextPopup} from "./plugins-popup/credit-text-popup";

interface IPlansProps {
    setShowPluginsPopup:Function
}

export const PlansPricingDesignNew = (props:IPlansProps) => {

//console.log('PlansPricingDesignNew: ',props);
    const PageData = useAppSelector((store) => store.PageData);
    const CreditTextPopupShow = useAppSelector((store) => store.CreditTextPopupShow);

    const IsPriceDifferent = useAppSelector((store) => store.IsPriceDifferent);
    const IsAnnual = useAppSelector((store) => store.IsAnnual);


    //console.log('PageData:',PageData);
    const dispatch = useAppDispatch();

    const StarterPlanAnnual = PageData.subscriptionPlans.filter(plan => plan.sbsTypeID === 2 && plan.tierLowHigh.endsWith("low"))[0];
    const StarterPlanMonthly = PageData.subscriptionPlans.filter(plan => plan.sbsTypeID === 1 && plan.tierLowHigh.endsWith("low"))[0];
    const StarterPlan = IsAnnual ?
        PageData.subscriptionPlans.filter(plan => plan.sbsTypeID === 2 && plan.tierLowHigh.endsWith("low"))[0] :
        PageData.subscriptionPlans.filter(plan => plan.sbsTypeID === 1 && plan.tierLowHigh.endsWith("low"))[0];

    const PremiumPlanAnnual = PageData.subscriptionPlans.filter(plan => plan.sbsTypeID === 2 && plan.tierLowHigh.endsWith("high"))[0];
    const PremiumPlanMonthly = PageData.subscriptionPlans.filter(plan => plan.sbsTypeID === 1 && plan.tierLowHigh.endsWith("high"))[0];
    const PremiumPlanSave:number = Number(((PremiumPlanMonthly.skU_MSRP * 12) - PremiumPlanAnnual.skU_MSRP).toFixed(2));
    const PremiumPlan = IsAnnual ?
        PageData.subscriptionPlans.filter(plan => plan.sbsTypeID === 2 && plan.tierLowHigh.endsWith("high"))[0] :
        PageData.subscriptionPlans.filter(plan => plan.sbsTypeID === 1 && plan.tierLowHigh.endsWith("high"))[0];

    //if StarterPlan.numberOfFreeDays > 0 --> button's text :  Start Free 7-Day Trial
    //else --> button's text :  Get Access
    const StarterButtonText = StarterPlan.numberOfFreeDays > 0 ? "Start Free "+StarterPlan.numberOfFreeDays+"-day Trial" : "Subscribe Now";
    const PremiumButtonText = PremiumPlan.numberOfFreeDays > 0 ? "Start Free "+PremiumPlan.numberOfFreeDays+"-day Trial" : "Subscribe Now";

    //console.log('PremiumPlanSave: ',PremiumPlanSave);
    const ShowPluginsPopup = (plan? : SubscriptionPlanModel) => {

        sendGAEvent('Click', 'open plugins popup');

        props.setShowPluginsPopup(true);

        dispatch(
            rootActions.main({
                PlanOnMobilePluginsPopup:plan,
                ShowPluginImageSortIncludesID:-1,
                SearchFilterKey:""
            })
        )

    }
    const CreditTextPopupShowClick = () => {
        dispatch(
            rootActions.main({
                CreditTextPopupShow:true
            })
        )
    }


    return (
        <div className="new-design flex items-center pt-0 md:pt-8 lg:pt-12" id="plans-container">
            <div className={`w-full waves-box-ml mx-auto bg-dark-blue1 text-white`}
                 style={{borderBottom: "1px solid #0f1b2b"}}>
                <div className="flex items-center justify-center">
                    <div className="relative w-fit  mt-8 md:mt-0">
                        <div className="sbs-plans-arrow absolute"><SbsPlansArrowIcon width="100%"/></div>
                        {!IsPriceDifferent &&
                            <p className="text-center pb-1 pay-annually-text" >Pay annually &amp; <span
                                style={{color: "#EFFF00"}}> save up to <ProductPriceFormat
                                price={PremiumPlanSave}/> </span></p>
                        }
                        {IsPriceDifferent &&
                            <p className="text-center pb-1 pay-annually-text">Pay annually &amp; <span
                                style={{color: "#EFFF00"}}> save</span></p>
                        }
                        <div
                            className="flex items-center justify-center text-xl md:text-xl lg:text-2xl xl:text-3xl p-2">
                            <div className={`${!IsAnnual ? "font-bold" : ""}`} aria-hidden="true">Monthly</div>
                            <div className="mx-2">
                                <ToggleStyled
                                    padding={4}
                                    handleColor={"#EFFF00"}
                                    width={57}
                                    height={29}
                                    isToogle={IsAnnual}
                                    adaText={IsAnnual ? 'Annually plan selected' : 'Monthly plan selected'}
                                    // onClick={(isToogle: boolean) => SetIsAnnual(!IsAnnual, dispatch)}
                                    onClick={(isToogle: boolean) => SetIsAnnual(!IsAnnual, dispatch)}
                                    textStyles={{
                                        margiLeft: '-5px'
                                    }}
                                />
                            </div>
                            
                            <div className={`${IsAnnual ? "font-bold" : ""}`} aria-hidden="true">Annual</div>

                        </div>
                    </div>
                </div>
                <div className="w-full lg:flex lg:justify-start my-8 md:mt-0 md:mb-8 lg:my-4 px-5 md:px-12 lg:px-0  text-left plans-container">
                    <div className="w-full relative lg:w-1/2 lg:mr-8 xl:mr-12 bg-fade-design-new-essential rounded-2xl mt-10">
                        <div
                            className="w-full text-3xl md:text-4xl xl:text-5xl font-bold px-8 lg:pl-16 pt-8 md:pt-8 lg:pt-0 mt-8 md:mt-16 lg:mt-16 font-montserrat">
                            {/*{StarterPlan.tierName}*/}
                            <span className="font-normal">Waves</span> <span>Essential</span>
                        </div>


                        {/*here if default*/}

                        <div>
                            {/*<div*/}
                            {/*    className="w-full text-tiny md:text-lg lg:text-xl mt-1 md:pt-2 lg:pt-1 lg:px-8 md:h-16">*/}
                            {/*    <span dangerouslySetInnerHTML={{__html: StarterPlan.tagline}}/></div>*/}
                            <div
                                className="plugins-count w-full text-yellow-400 font-bold px-8 lg:pl-16">120+
                                Plugins
                            </div>

                        </div>


                        <div
                            className="flex justify-start mt-4 px-8 lg:pl-16 w-full text-2xl md:text-4xl xl:text-5xl font-bold">
                            {!IsPriceDifferent && <Price plan={StarterPlan} isStarter={true} caller="PlansPricingDesignNew"/>}
                            {IsPriceDifferent && <PriceDifferent plan={StarterPlan} isStarter={true} showCounter={true}/>}
                        </div>


                        {!IsPriceDifferent &&
                            <div
                                className="flex justify-start bg-new-design-gray-1 mt-5 lg:mt-4 pb-5 lg:pb-4 px-8 lg:pl-16 w-full text-2xl md:text-4xl xl:text-5xl font-bold">
                                <TwoMonthFree
                                    PlanAnnual={StarterPlanAnnual}
                                    PlanMonthly={StarterPlanMonthly}
                                />
                            </div>
                        }
                        {IsPriceDifferent &&
                            <TwoMonthFreePriceDifferent
                                PlanAnnual={StarterPlanAnnual}
                                PlanMonthly={StarterPlanMonthly}
                                styleType="left"
                            />
                        }

                        <div className="flex items-center justify-start px-8 lg:pl-16 mt-6">
                            <StarRating
                                rating={StarterPlan.rating}
                                reviews={StarterPlan.reviewsTotal}
                                // url={ StarterPlan.documentUrlPath }
                                urlHash="reviews"
                                clickByAttribute={`[data-id="waves-essential-review"]`}
                                className="mb-4 flex items-center justify-center"
                                colorClass="text-white"
                                gaEventName={'Click Reviews'}
                                gaEventValue={StarterPlan.tierName}
                            />
                        </div>

                        <div className="w-full px-8 lg:pl-16 mt-6 flex items-center justify-start">
                            <button onClick={() => AddToCart(StarterPlan)}
                                    className="text-white no-underline font-medium bg-new-design-button-1 px-12 md:px-24 xl:px-10 py-3.5 md:py-3 rounded-full text-base md:text-xl xl:text-xl cursor-pointer w-fit">{StarterButtonText}</button>
                        </div>

                        <div
                            className="w-full text-xl md:text-sm lg:text-xl pl-8 lg:pl-16 mt-6 md:mt-8 lg:mt-10 mb-0 md:mb-0">
                            <div className="benefits-text">
                                <p className="pt-3 flex flex-row items-center">120+ plugins:
                                    <button onClick={() => ShowPluginsPopup(StarterPlan)}
                                        className="text-white font-bold underline cursor-pointer w-auto px-1"> See list</button>
                                    <ArrowIcon
                                        width="11px"
                                        color="white"
                                        title="Arrow Down"
                                        rotationAngle={-90}
                                    />
                                </p>
                                <p className="pt-3">All plugin updates included</p>
                                <p className="pt-3">Selected new plugins added</p>
                                <p className="pt-3">2 licenses</p>
                                <p className="pt-3">Waves Stream: Remote audio collaboration</p>
                                <p className="pt-3">StudioVerse mix chain library</p>
                                <p className="pt-3">Premium mixing courses</p>
                                <p className="pt-3">Cancel anytime (effective next cycle)</p>
                                <div className="pt-3 hidden lg:block">&nbsp;</div>
                            </div>

                            <div className="flex items-center justify-start mt-8 md:mt-8 pb-8 md:pb-12">
                                <a href={StarterPlan.documentUrlPath}
                                   className="pr-2 text-white font-bold text-xl md:text-lg lg:text-xl">Explore
                                    Essential</a>
                                <ArrowIcon
                                    width="11px"
                                    color="white"
                                    title="Arrow Down"
                                    rotationAngle={-90}
                                />
                            </div>

                        </div>
                    </div>
                    <div
                        className="w-full lg:w-1/2 bg-fade-design-new-ultimate rounded-2xl relative mt-16 md:mt-24 lg:mt-10">

                        <div
                            className="badge-popular w-auto text-white text-tiny md:text-xl py-2 md:py-3 px-4 md:px-8 rounded-full absolute-center top-0">
                            Popular
                        </div>


                        <div
                            className="w-full text-3xl md:text-4xl xl:text-5xl  px-8 lg:pl-16 font-bold pt-10 md:pt-12 lg:pt-0 mt-8 md:mt-16 font-montserrat">
                            {/*{PremiumPlan.tierName}*/}
                            <span className="font-normal">Waves</span> <span>Ultimate</span>
                        </div>

                        {/*here if default*/}

                        <div>
                            {/*<div*/}
                            {/*    className="w-full text-tiny md:text-lg lg:text-xl mt-1 md:pt-2 lg:pt-1 lg:px-8 md:h-16">*/}
                            {/*    <span dangerouslySetInnerHTML={{__html: PremiumPlan.tagline}}/></div>*/}
                            <div
                                className="plugins-count w-full text-yellow-400 font-bold px-8 lg:pl-16">240+
                                Plugins
                            </div>

                        </div>

                        <div
                            className="flex justify-start mt-4 px-8 lg:pl-16 w-full text-2xl md:text-4xl xl:text-5xl font-bold">
                            {!IsPriceDifferent && <Price plan={PremiumPlan} isStarter={false} caller="PlansPricingDesignNew"/>}
                            {IsPriceDifferent && <PriceDifferent plan={PremiumPlan} isStarter={false} showCounter={true}/>}
                        </div>


                        {
                            !IsPriceDifferent &&
                            <div
                                className="flex justify-start bg-new-design-purple-1 mt-5 lg:mt-4 pb-5 lg:pb-4 px-8 lg:pl-16 w-full text-2xl md:text-4xl xl:text-5xl font-bold">
                                <TwoMonthFree
                                    PlanAnnual={PremiumPlanAnnual}
                                    PlanMonthly={PremiumPlanMonthly}
                                />
                            </div>
                        }
                        {
                            IsPriceDifferent &&
                            <TwoMonthFreePriceDifferent
                                PlanAnnual={PremiumPlanAnnual}
                                PlanMonthly={PremiumPlanMonthly}
                                styleType="left"
                            />}

                        <div className="flex items-center justify-start px-8 lg:pl-16 mt-6">
                            <StarRating
                                rating={PremiumPlan.rating}
                                reviews={PremiumPlan.reviewsTotal}
                                // url={ PremiumPlan.documentUrlPath }
                                urlHash="reviews"
                                clickByAttribute={`[data-id="waves-ultimate-review"]`}
                                className="mb-4 flex items-center justify-center"
                                colorClass="text-white"
                                gaEventName={'Click Reviews'}
                                gaEventValue={PremiumPlan.tierName}
                            />
                        </div>

                        <div className="w-full px-8 lg:pl-16 mt-6 flex items-center justify-start">
                            <button
                                type="button"
                                onClick={() => AddToCart(PremiumPlan)}
                                className="text-black no-underline font-medium bg-yellow px-12 md:px-24 xl:px-10 py-3.5 md:py-3 rounded-full text-base md:text-xl xl:text-xl w-fit cursor-pointer">{PremiumButtonText}</button>
                        </div>

                        <div
                            className="w-full text-xl md:text-sm lg:text-xl pl-6 lg:pl-16 mt-6 md:mt-8 lg:mt-10 mb-0 md:mb-0">
                            <div className="benefits-text">
                                <p className="pt-3 flex flex-row items-center">240+ plugins:
                                    <button onClick={() => ShowPluginsPopup(PremiumPlan)}
                                        className="text-white font-bold underline cursor-pointer w-auto px-1"> See list</button>
                                    <ArrowIcon
                                        width="11px"
                                        color="white"
                                        title="Arrow Down"
                                        rotationAngle={-90}
                                    />
                                </p>
                                <p className="pt-3">All plugin updates included</p>
                                <p className="pt-3">New plugins added regularly</p>
                                <p className="pt-3">2 licenses</p>
                                <p className="pt-3">Waves Stream: Remote audio collaboration</p>
                                <p className="pt-3">StudioVerse mix chain library</p>
                                <p className="pt-3">Premium mixing courses</p>
                                <p className="pt-3">Cancel anytime (effective next cycle)</p>
                                {IsAnnual &&

                                    <div className="flex flex-row items-center">
                                        <p className="pt-3">
                                            30 Online Mastering credits / year
                                        </p>
                                        <button type="button" className="pl-1 pt-3 cursor-pointer "
                                                onClick={CreditTextPopupShowClick}><InfoIcon width={"16px"}
                                                                                             color={"#ffffff"}/>
                                        </button>
                                    </div>
                                }
                                {!IsAnnual &&
                                    <div className="flex flex-row items-center">
                                        <p className="pt-3">
                                            2 Online Mastering credits / month
                                        </p>
                                        <button type="button" className="pl-1 pt-3 cursor-pointer"
                                                onClick={CreditTextPopupShowClick}><InfoIcon width={"16px"}
                                                                                             color={"#ffffff"}/>
                                        </button>
                                    </div>
                                }
                            </div>

                            <div className="flex items-center justify-start mt-8 md:mt-8 pb-8 md:pb-12">
                                <a href={PremiumPlan.documentUrlPath}
                                   className="pr-2 text-white font-bold text-xl md:text-lg lg:text-xl">Explore
                                    Ultimate</a>
                                <ArrowIcon
                                    width="11px"
                                    color="white"
                                    title="Arrow Down"
                                    rotationAngle={-90}
                                />
                            </div>
                        </div>

                    </div>

                </div>

            </div>
            {CreditTextPopupShow && <CrediteTextPopup />}
        </div>
    )
};